import { render } from "./AddMember.vue?vue&type=template&id=4067a60b"
import script from "./AddMember.vue?vue&type=script&lang=js"
export * from "./AddMember.vue?vue&type=script&lang=js"

import "./AddMember.vue?vue&type=style&index=0&id=4067a60b&lang=css"

import exportComponent from "C:\\Users\\yiche\\OneDrive\\Desktop\\NUS\\Y2S2\\BT3103\\MyTeam\\my-team\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__